goog.provide("el8.apphome.docMgr.FileFeed");

goog.require("el8.apphome.docMgr.FileFeedRenderer");
goog.require("el8.apphome.docMgr.ImageSelector");
goog.require("el8.apphome.docMgr.renderer");
goog.require("el8.apphome.docMgr.util");
goog.require("el8.appshared.dialog.imagesZoom");
goog.require("el8.practicedata.base");
goog.require("el8.practicedata.incomingFileGroups");
goog.require("el8.practicedata.unfiledInboxes");
goog.require("el8.practicedata.uploadedFiles");
goog.require("el8.practicedata.uploadedImages");
goog.require("el8.template.render.docMgr");
goog.require("el8.template.util.feed");
goog.require("el8.uiwidget.alert");
goog.require("el8.uiwidget.confirm");
goog.require("el8.uiwidget.deleteConfirm");
goog.require("el8.uiwidget.NewActionsMenu");
goog.require('el8.util.amplitude.documentHelpers');

/**
 * Note: we assume that FileGroup's either have ONLY images or ONLY files, not both
 */

el8.apphome.docMgr.FileFeed = function (spec) {
    this._PAGE_SIZE = 5;

    this._IMAGE_WIDTH = 350;
    this._IMAGE_HEIGHT = 452;
    this._imageWrapSelector = ".image-item-wrap";

    this._dialogContainer = spec.dialogContainer;
    this._fileGroupContainer = spec.fileGroupContainer;
    this._inboxContainer = spec.inboxContainer;

    this._fileGroupId = spec.fileGroupId;
    this._hasImages = spec.hasImages; // assume either ONLY images or ONLY files
    this._inboxId = spec.inboxId;
    this._sorter = spec.sorter;
    this._actionsMenu = spec.actionsMenu;

    this._loadFileFn = spec.loadFileFn;
    this._removeFileFn = spec.removeFileFn;
    this._destroyFn = spec.destroyFn;

    var that = this;
    $.extend(spec, {
        name: "filegroup-" + that._fileGroupId,
        emptyMsg: "No images in this group",
        rendererFn: function (item) {
            var mClass = item.getModelClass();
            switch (mClass) {
                case "UploadedImage":
                    return function (item, feedItemId) {
                        var obj = item.asSoyMap();
                        obj["feedItemId"] = feedItemId;
                        obj["isQueuedForSort"] = that._sorter.hasItem(
                            item.getId()
                        );
                        return el8.template.render.docMgr.organizer.imageContent(
                            obj
                        );
                    };
                case "UploadedFile":
                    return function (item, feedItemId) {
                        var obj = item.asSoyMap();
                        obj["feedItemId"] = feedItemId;
                        obj["isQueuedForSort"] = that._sorter.hasItem(
                            item.getId()
                        );
                        return el8.template.render.docMgr.organizer.fileContent(
                            obj
                        );
                    };
            }
            return null;
        },
        fetchFn: function (arg, force, async) {
            var returnSingle = false;
            if (!(arg instanceof Array)) {
                returnSingle = true;
                arg = [arg];
            }
            var idList = arg.map(function (a) {
                return a.id;
            });
            var result = [];
            idList.map(function (id) {
                result.push(el8.practicedata.getUploadedFileOrImage(id));
            });
            return returnSingle ? result[0] : result;
        },
        addlRenderItemFn: function ($elt) {
            $(that._imageWrapSelector, $elt)
                .outerHeight(that._IMAGE_HEIGHT)
                .outerWidth(that._IMAGE_WIDTH);
            if ($elt.find(".image-item").length) {
                el8.apphome.docMgr.util.loadImage($elt, {
                    imageClass: "thumbnail",
                    forceRefresh: false,
                    width: that._IMAGE_WIDTH,
                    imageWrapSelector: that._imageWrapSelector,
                    successCb: function () {
                        that._updateLockDisplay($elt);
                    },
                });
            }
        },
        addlRenderFn: function (renderer) {
            // If there's still a "more" button, remove and put in right place
            $(".file-feed-more", renderer.getListElt()).remove();
            if (!renderer.isNextPageEmpty()) {
                renderer.getListElt().append(
                    el8.template.render.docMgr.organizer.fileFeedMore({
                        fileGroupId: that._fileGroupId,
                    })
                );
            }
        },
        pageSize: that._PAGE_SIZE,
        skeletonFn: function (_spec) {
            _spec = _spec || {};
            _spec.fileGroupId = that._fileGroupId;
            return el8.template.render.docMgr.organizer.fileFeed(_spec);
        },
        moreTrigger: "#filegroup-" + that._fileGroupId + "-feed-more-btn",
        clickTriggerMap: {
            ".remove-lock-trigger": function ($target) {
                var $thumbnail = $target.closest(".thumbnail-item");
                var itemId = $thumbnail.attr("data-id") * 1;
                var item = el8.practicedata.getUploadedFileOrImage(itemId);
                item.setLockRemoved(true);
                that.refreshItem(item);
            },
            ".remove-queue-trigger": function ($target) {
                var $thumbnail = $target.closest(".thumbnail-item");
                var itemId = $thumbnail.attr("data-id") * 1;
                var item = el8.practicedata.getUploadedFileOrImage(itemId);
                that._dequeueImage(item);
                return false;
            },
            ".add-queue-trigger": function ($target) {
                var $thumbnail = $target.closest(".thumbnail-item");
                var itemId = $thumbnail.attr("data-id") * 1;
                var item = el8.practicedata.getUploadedFileOrImage(itemId);
                that._queueImage(item);
                return false;
            },
            ".actions-trigger": function ($target) {
                /* Note: only images have an actions dropdown */
                var $thumbnail = $target.closest(".thumbnail-item");
                if ($thumbnail.attr("data-lock")) {
                    return;
                }
                that._imageSelector.forceSelectImage($thumbnail);
                var menu = null;
                if (that._imageSelector.isMultipleSelected()) {
                    menu = [
                        {
                            actionText: "Rotate Left",
                            actionFn: function () {
                                that._rotateImages("left");
                            },
                        },
                        {
                            actionText: "Rotate 180",
                            actionFn: function () {
                                that._rotateImages("180");
                            },
                        },
                        {
                            actionText: "Rotate Right",
                            actionFn: function () {
                                that._rotateImages("right");
                            },
                        },
                    ];
                } else {
                    menu = [
                        {
                            actionText: "Rotate Left",
                            actionFn: function () {
                                that._rotateImages("left");
                            },
                        },
                        {
                            actionText: "Rotate 180",
                            actionFn: function () {
                                that._rotateImages("180");
                            },
                        },
                        {
                            actionText: "Rotate Right",
                            actionFn: function () {
                                that._rotateImages("right");
                            },
                        },
                        {
                            actionText: "Zoom",
                            actionFn: function () {
                                var itemIds = that._getSelectedItemIds();
                                if (itemIds.length) {
                                    var item = el8.practicedata.uploadedImages.getById(
                                        itemIds[0]
                                    );
                                    el8.appshared.dialog.imagesZoom.show({
                                        images: [item.getPrintUrl()],
                                    });
                                }
                            },
                        },
                        {
                            actionText: "Print",
                            actionFn: function () {
                                that._printImages();
                            },
                        },
                        {
                            actionText: "Delete",
                            actionFn: function () {
                                if (el8Globals.FEATURES.RestoreDeletedFaxes) {
                                    el8.uiwidget.confirm("Are you sure you want to delete this file? You can restore it later from the Recently Deleted view.", function () {
                                        that._deleteImages();
                                    });
                                } else {
                                    el8.uiwidget.deleteConfirm("file", function () {
                                        that._deleteImages();
                                    });
                                }
                            },
                        },
                    ];
                }
                var extra = $(
                    ".upload-queue",
                    that._inboxContainer
                ).outerHeight(true) || 0;
                that._actionsMenu.display(
                    $target,
                    null,
                    { top: 60 + extra, left: 25 },
                    menu,
                    2
                );
                return false;
            },
        },
    });

    // Initialize image selector
    this._mouseenter = false;
    this._imageSelector = new el8.apphome.docMgr.ImageSelector({
        container: this._fileGroupContainer,
        counterSelector: ".image-count",
        selectedImagesOnFn: function () {
            that._updateActions(true);
        },
        selectedImagesOffFn: function () {
            that._updateActions(false);
        },
    });

    $.extend(spec, {
        imageWrapSelector: this._imageWrapSelector,
        rendererConstructor: el8.apphome.docMgr.FileFeedRenderer,
        imageSelector: this._imageSelector,
        sorterHasIdFn: function (itemId) {
            return that._sorter && that._sorter.hasItem(itemId);
        },
        renderEmptyFn: function () {
            that.destroy();
            if (that._destroyFn) {
                that._destroyFn();
            }
        },
    });

    el8.uiwidget.Feed.prototype.constructor.call(this, spec);
};
el8.apphome.docMgr.FileFeed.inheritsFrom(el8.uiwidget.Feed);

el8.apphome.docMgr.FileFeed.prototype.init = function () {
    this.parent.init.call(this);
    this._bindTriggers();
    this._updateActions(false);
    return this;
};
el8.apphome.docMgr.FileFeed.prototype.display = function () {
    this.parent.display.call(this);
    this._imageSelector.startListen();
};
el8.apphome.docMgr.FileFeed.prototype.hide = function () {
    this.parent.hide.call(this);
    this._imageSelector.stopListen();
};

/**
 * Rendering methods
 */
el8.apphome.docMgr.FileFeed.prototype.refreshImage = function (itemId) {
    var that = this;
    var $elt = this.getRenderItem(itemId);
    $(this._imageWrapSelector, $elt)
        .outerHeight(this._IMAGE_HEIGHT)
        .outerWidth(this._IMAGE_WIDTH);
    var $img = $("img", $elt);
    if (!$img.is(":visible")) {
        /* If the image is hidden, it failed to rotate at some point. We're
         * about to reload it, so undo that error state. If this fails too,
         * we have our own error state for that. */
        $img.show();
        $(".image-failed-rotation-text", $elt).remove();
    }
    el8.apphome.docMgr.util.refreshImage($img, {
        imageWrapSelector: this._imageWrapSelector,
        width: that._IMAGE_WIDTH,
        successCb: function ($newImg) {
            if ($elt.attr("data-lock")) {
                var $itemWrap = $(that._imageWrapSelector, $elt);
                var $lock = $(".image-lock", $elt);
                var $lockWrap = $(".image-lock-wrap", $elt);

                $lock
                    .outerWidth($itemWrap.width() || 0)
                    .outerHeight($itemWrap.height() || 0);
                $lockWrap
                    .css(
                        "margin-top",
                        ($itemWrap.height() || 0 / 2) -
                            ($lockWrap.innerHeight() || 0) / 2
                    )
                    .outerWidth($itemWrap.width());
            }
        },
    });
};
el8.apphome.docMgr.FileFeed.prototype._updateLockDisplay = function ($elt) {
    if ($elt.attr("data-lock")) {
        var $itemWrap = $(this._imageWrapSelector, $elt);
        var $lock = $(".image-lock", $elt);
        var $lockWrap = $(".image-lock-wrap", $elt);

        $lock.outerWidth($itemWrap.width() || 0).outerHeight($itemWrap.height() || 0);

        $lockWrap
            .css(
                "margin-top",
                ($itemWrap.height() || 0) / 2 -
                    ($lockWrap.innerHeight() || 0) / 2
            )
            .outerWidth($itemWrap.width());
    }
};

/**
 * Over-ride loadIndex() so we add to the organizer's global feed
 */
el8.apphome.docMgr.FileFeed.prototype.loadIndex = function (index) {
    this.parent.loadIndex.call(this, index);
    // Aggressively add fileId's to the map (in loadFileFn)
    for (var i = 0; i < index.length; i++) {
        this._loadFileFn(index[i].id, this._inboxId, this._fileGroupId);
    }
};

/**
 * Over-ride remove so we remove from organizer's global feed and manage
 * image selector
 */
el8.apphome.docMgr.FileFeed.prototype.remove = function (itemId, duration) {
    var retVal = el8.uiwidget.Feed.prototype.remove.apply(this, arguments);

    /* Remove image from imageSelector */
    if (this._imageSelector) {
        this._imageSelector.removeImage(itemId);
    }

    /* Remove from organizer's global feed */
    this._removeFileFn(itemId, this._fileGroupId);

    return retVal;
};

/**
 * Helper methods to manage image selection and actions
 */
el8.apphome.docMgr.FileFeed.prototype._updateActions = function (hasSelected) {
    var $batchActions = $(".batch-actions", this._fileGroupContainer);
    var $feedQueueButtons = $(
        "button.el8FeedButton.add-queue-trigger",
        this._fileGroupContainer
    );
    if (hasSelected) {
        $("button", $batchActions).prop('disabled', false);
        if (this._imageSelector.isMultipleSelected()) {
            $feedQueueButtons.prop('disabled', true);
            $feedQueueButtons.hide();
        }
    } else {
        if (!this._imageSelector.isAnySelected()) {
            $("button", $batchActions).prop('disabled', true);
        } else if (!this._imageSelector.isMultipleSelected()) {
            $feedQueueButtons.prop('disabled', false);
            $feedQueueButtons.show();
        }
    }
};
el8.apphome.docMgr.FileFeed.prototype.clearSelection = function () {
    this._imageSelector.clearSelection();
};
el8.apphome.docMgr.FileFeed.prototype._bindTriggers = function () {
    var that = this;
    $(".batch-actions", this._fileGroupContainer).on(
        "click",
        "button",
        function (e) {
            var action = $(this).attr("data-action");
            that._doButtonAction(action, $(this));
            return false;
        }
    );
    this._fileGroupContainer.on("click", ".toggle-select-all", function (e) {
        var $this = $(this);
        if ($this.data("mode") === "select") {
            $this.data("mode", "deselect");
            $this.text("Select None");
            that.selectAllImages();
        } else {
            $this.data("mode", "select");
            $this.text("Select All");
            that.clearSelection();
        }
    });
};
el8.apphome.docMgr.FileFeed.prototype.selectAllImages = function () {
    if (!this._feedRenderer.isNextPageEmpty()) {
        this.showAllPages();
    }
    this._imageSelector.selectAllImages();
};

/**
 * Taking actions on images
 */
el8.apphome.docMgr.FileFeed.prototype._rotateImages = function (
    direction,
    itemIds,
    successFn,
    errorFn
) {
    itemIds = itemIds || this._getSelectedItemIds();
    el8.appservice.notifier.notify(
        (itemIds.length > 1
            ? "Rotating images " + direction
            : "Rotating image " + direction) + "..."
    );
    var genCallbackFn = function (itemId, $imgWrapper) {
        return function () {
            $imgWrapper.removeClass("imageLoading");
            if (successFn) {
                successFn();
            }
            el8.appservice.notifier.notify(
                itemIds.length > 1 ? "Images rotated" : "Image rotated"
            );
            el8.practicedata.uploadedImages.realtimeNotify(
                itemId,
                "UPDATED_IMAGE"
            );
        };
    };
    var genErrorFn = function (itemId, $imgWrapper) {
        return function () {
            $imgWrapper.removeClass("imageLoading");
            var $img = $("img", $imgWrapper);
            $img.hide().after(el8.template.util.feed.failedImageRotation());
            if (errorFn) {
                errorFn();
            }
        };
    };
    for (var i = 0; i < itemIds.length; i++) {
        var itemId = itemIds[i];

        // show that we're doing work
        var $imgWrapper = $(
            this._imageWrapSelector,
            this.getRenderItem(itemId)
        );
        $("img", $imgWrapper).hide();
        $imgWrapper.addClass("imageLoading");

        el8.practicedata.uploadedImages.rotateImage({
            id: itemId,
            direction: direction,
            size: "organizer",
            successCb: genCallbackFn(itemId, $imgWrapper),
            errorOverrideCb: genErrorFn(itemId, $imgWrapper),
        });
    }
};
el8.apphome.docMgr.FileFeed.prototype._printImages = function (itemIds) {
    itemIds = itemIds || this._getSelectedItemIds();
    el8.practicedata.uploadedImages.printImages(itemIds);
};
el8.apphome.docMgr.FileFeed.prototype._deleteImages = function (itemIds) {
    itemIds = itemIds || this._getSelectedItemIds();
    for (var i = 0; i < itemIds.length; i++) {
        var item = el8.practicedata.getUploadedFileOrImage(itemIds[i]);
        el8.practicedata
            .getEntitySet(item.getModelClass())
            .deleteItem(item, false, { async: false });
        el8.practicedata
            .getEntitySet(item.getModelClass())
            .realtimeNotify(itemIds[i], "DELETED");
    }
};
el8.apphome.docMgr.FileFeed.prototype._restoreItems = function (itemIds, successFn, errorFn) {
    itemIds = itemIds || this._getSelectedItemIds();
    for (var i = 0; i < itemIds.length; i++) {
        var itemId = itemIds[i];
        var item = el8.practicedata.getUploadedFileOrImage(itemId);
        el8.practicedata.getEntitySet(item.getModelClass()).restoreItem({
            id: itemId,
            successCb: successFn,
            errorOverrideCb: errorFn,
        });
        el8.practicedata.getEntitySet(item.getModelClass()).realtimeNotify(itemId, "UPDATED");
    }
    el8.appservice.notifier.notify(
        itemIds.length + (itemIds.length > 1 ? " images" : " image") + " restored successfully"
    );
    el8.util.amplitude.logRestoreDeletedFax(itemIds.length);
};
el8.apphome.docMgr.FileFeed.prototype._queueImages = function (itemIds) {
    itemIds = itemIds || this._getSelectedItemIds();
    var items = itemIds.map(function (id) {
        return el8.practicedata.getUploadedFileOrImage(id);
    });

    for (var i = 0; i < items.length; i++) {
        this._queueImage(items[i]);
    }
};
el8.apphome.docMgr.FileFeed.prototype._queueImage = function (item) {
    this._sorter.queueItem(item);
};
el8.apphome.docMgr.FileFeed.prototype._dequeueImage = function (item) {
    this._sorter.dequeueItem(item.getId());
};

/**
 * Helper methods for taking actions on images
 */
el8.apphome.docMgr.FileFeed.prototype._getSelectedItemIds = function () {
    var ids = [];
    $('input:checked[type="checkbox"]', this._container).each(function (
        index,
        elt
    ) {
        ids.push($(elt).attr("data-id") * 1);
    });
    return ids;
};
el8.apphome.docMgr.FileFeed.prototype._doButtonAction = function (
    action,
    $btn
) {
    var itemIds = this._getSelectedItemIds();
    if (!itemIds.length) {
        el8.uiwidget.alert("Sorry, please select at least one document.");
        return;
    }
    var that = this;

    var enableBtnFn = function () {
        $btn.prop('disabled', false);
    };

    switch (action) {
        case "add-queue":
            this._queueImages(itemIds);
            return;
        case "delete":
            if (el8Globals.FEATURES.RestoreDeletedFaxes) {
                var singularOrPluralFile = "this file";
                var filePronoun = "it";
                if (itemIds.length > 1) {
                    singularOrPluralFile = "these files";
                    filePronoun = "them";
                }
                var confirmMessage = "Are you sure you want to delete " + singularOrPluralFile + "? You can restore " + filePronoun +  " later from the Recently Deleted view."
                el8.uiwidget.confirm(confirmMessage, function () {
                    that._deleteImages(itemIds);
                });
            } else {
                el8.uiwidget.deleteConfirm("file", function () {
                    that._deleteImages();
                });
            }
            return;
        case "rotate-180":
            $btn.prop('disabled', true);
            this._rotateImages("180", itemIds, enableBtnFn, enableBtnFn);
            break;
        case "rotate-right":
            $btn.prop('disabled', true);
            this._rotateImages("right", itemIds, enableBtnFn, enableBtnFn);
            break;
        case "rotate-left":
            $btn.prop('disabled', true);
            this._rotateImages("left", itemIds, enableBtnFn, enableBtnFn);
            break;
        case "restore":
            $btn.prop('disabled', true);
            this._restoreItems(itemIds, enableBtnFn, enableBtnFn);
            break;
        case "clear":
            this.clearSelection();
            break;
    }
};
